/*
 * Footer Messages
 *
 * This contains all the text for the Footer.
 */

import { defineMessages } from "react-intl";

export const scope = "app.Footer.newTreatmentPatientInfo";

export default defineMessages({
  assistantPun: {
    id: `${scope}.assistantPun`,
    defaultMessage: "Need Assist-teethy?",
  },
});
